"use strict";

exports.__esModule = true;
exports.DashboardFilter = DashboardFilter;
exports.FilterButton = FilterButton;
exports.FilterMenu = FilterMenu;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _icons = require("@blueprintjs/icons");
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
var _PlantStateFilterContext = require("../../PlantStateActivities/PlantStateFilterContext");
var _reactIntl = require("react-intl");
var _timeDefinitions = require("../../timeDefinitions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "DashboardFilter__Wrapper",
  componentId: "sc-l2uxm-0"
})(["max-width:190px;"]);
var FilterText = (0, _styledComponents["default"])(_core.Text).withConfig({
  displayName: "DashboardFilter__FilterText",
  componentId: "sc-l2uxm-1"
})(["max-width:180px;"]);
var FilterPlaceHolderText = (0, _styledComponents["default"])(_core.Text).withConfig({
  displayName: "DashboardFilter__FilterPlaceHolderText",
  componentId: "sc-l2uxm-2"
})(["padding-left:10px;max-width:180px;"]);
function FilterMenu(props) {
  var items = props.items,
    onSelectFilter = props.onSelectFilter,
    selected = props.selected;
  function handleSelect(items) {
    onSelectFilter(items);
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      shouldDismissPopover: false,
      key: item.id,
      icon: selected.some(function (i) {
        return i.id === item.id;
      }) ? _icons.IconNames.TICK : _icons.IconNames.BLANK,
      text: item.name,
      onClick: function onClick() {
        if (selected.some(function (i) {
          return i.id === item.id;
        })) {
          handleSelect(selected.filter(function (i) {
            return item.id !== i.id;
          }));
        } else {
          handleSelect(selected.concat(item));
        }
      }
    });
  }));
}
function DashboardFilter(props) {
  var items = props.items,
    onSelectFilter = props.onSelectFilter,
    selected = props.selected,
    setRefreshInterval = props.setRefreshInterval,
    refreshInterval = props.refreshInterval;
  var isSelected = function isSelected(interval) {
    return refreshInterval === interval * _timeDefinitions.MINUTE_IN_MILLIS;
  };
  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_core.Menu, null, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    shouldDismissPopover: false,
    text: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        textAlign: "center"
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        margin: "auto",
        display: "table",
        border: "2px",
        marginTop: "10px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "DashboardFilter.refreshInterval.helperText",
      defaultMessage: "Select Refresh Interval"
    }))), /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      fill: true
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      active: isSelected(5),
      onClick: function onClick() {
        return setRefreshInterval((0, _timeDefinitions.getMinutesMillis)(5));
      }
    }, "5m"), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      onClick: function onClick() {
        return setRefreshInterval((0, _timeDefinitions.getMinutesMillis)(15));
      },
      active: isSelected(15)
    }, "15m"), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      onClick: function onClick() {
        return setRefreshInterval((0, _timeDefinitions.getMinutesMillis)(30));
      },
      active: isSelected(30)
    }, "30m")))
  }), /*#__PURE__*/_react["default"].createElement(_core.MenuDivider, null), /*#__PURE__*/_react["default"].createElement(FilterMenu, {
    style: {
      maxWidth: 250,
      marginRight: "1rem"
    },
    key: "DashBoard.StateFilterMenu",
    items: items,
    onSelectFilter: onSelectFilter,
    selected: selected
  })));
}
function FilterButton(props) {
  var translator = _react["default"].useContext(_Translator.TranslatorContext);
  var _React$useContext = _react["default"].useContext(_PlantStateFilterContext.PlantStateFilterContext),
    onRefresh = _React$useContext.onRefresh,
    setRefreshInterval = _React$useContext.setRefreshInterval,
    refreshInterval = _React$useContext.refreshInterval,
    shouldRefresh = _React$useContext.shouldRefresh;
  var _useState = (0, _react.useState)({}),
    showFilterMenu = _useState[0],
    setShowFilterMenu = _useState[1];
  var items = props.items,
    onSelectFilter = props.onSelectFilter,
    selected = props.selected;
  var onRefreshButtonClick = function onRefreshButtonClick() {
    onRefresh();
  };
  var selectionText = function selectionText() {
    if (!selected.length) {
      return /*#__PURE__*/_react["default"].createElement(FilterPlaceHolderText, {
        ellipsize: true,
        "data-testid": "placeholderText"
      }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "StateFilter.placeholder.multiple",
        defaultMessage: "Filter State"
      }));
    }
    return /*#__PURE__*/_react["default"].createElement(FilterText, {
      ellipsize: true,
      "data-testid": "selectionText"
    }, selected.map(function (item) {
      return item.name;
    }).join(","));
  };
  return /*#__PURE__*/_react["default"].createElement(_core.Popover, {
    canEscapeKeyClose: true,
    enforceFocus: false,
    content: /*#__PURE__*/_react["default"].createElement(DashboardFilter, {
      usePortal: false,
      icon: "filter",
      showFilterMenu: showFilterMenu,
      onBlur: function onBlur() {
        setShowFilterMenu({});
      },
      translate: translator && translator.translate,
      position: showFilterMenu.filterButton,
      items: items,
      onSelectFilter: onSelectFilter,
      selected: selected,
      refreshInterval: refreshInterval,
      setRefreshInterval: setRefreshInterval
    }),
    usePortal: false,
    interactionKind: _core.PopoverInteractionKind.CLICK
  }, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
    fill: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    rightIcon: "double-caret-vertical",
    minimal: true
  }, selectionText()), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    disabled: shouldRefresh,
    icon: "refresh",
    minimal: true,
    onClick: onRefreshButtonClick
  })));
}